import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { memo } from 'react';
import { Eyebrow } from "../../typography";
import { Container, ContentContainer, Description, Image, ImageContainer, Link, Title } from "./card.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Card = function Card(_ref) {
  var image = _ref.image,
    eyebrow = _ref.eyebrow,
    title = _ref.title,
    description = _ref.description,
    link = _ref.link;
  var containerProps = {
    as: 'div'
  };
  if (link) {
    containerProps = _objectSpread({
      as: 'a'
    }, link);
  }
  return /*#__PURE__*/_jsxs(Container, _objectSpread(_objectSpread({}, containerProps), {}, {
    children: [/*#__PURE__*/_jsx(ImageContainer, {
      children: /*#__PURE__*/_jsx(Image, _objectSpread({}, image))
    }), /*#__PURE__*/_jsxs(ContentContainer, {
      children: [eyebrow && /*#__PURE__*/_jsx(Eyebrow, {
        children: eyebrow
      }), /*#__PURE__*/_jsx(Title, {
        children: title
      }), description && /*#__PURE__*/_jsx(Description, {
        children: description
      }), link && /*#__PURE__*/_jsx(Link, {
        children: link.text
      })]
    })]
  }));
};
export default /*#__PURE__*/memo(Card);